import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchProjectsIfNeeded } from 'data/actions/projects';

import ProjectGrid from 'components/organisms/projectGrid';

class projectsContainer extends Component {
    componentDidMount() {
        this.props.fetchProjectsIfNeeded();
    }

    componentDidUpdate(prevProps, prevState) {}

    render() {
        return <ProjectGrid {...this.props} />;
    }
}

function getFilteredProjects(projects, filterSlug) {
    let filteredProjects = [];

    if (!projects) {
        return filteredProjects;
    }

    filteredProjects = projects.filter(item => {
        return item.fields.category.fields.slug === filterSlug;
    });

    return filteredProjects;
}

const mapStateToProps = (state, ownProps) => {
    let filter = ownProps.match.params.id;
    let projects = filter
        ? getFilteredProjects(state.projects.all, filter)
        : state.projects.all;

    return {
        projects: projects,
        hasError: state.projects.hasError,
        hasLoaded: state.projects.hasLoaded,
        isLoading: state.projects.isLoading
    };
};

projectsContainer = withRouter(
    connect(mapStateToProps, { fetchProjectsIfNeeded })(projectsContainer)
);

export default projectsContainer;



// WEBPACK FOOTER //
// ./src/data/containers/projects.js